













































import { defineComponent } from "@vue/composition-api";
import { BlockingStatus } from "@scrile/api-provider/dist/api/BlockingStatusProvider";
import { MessageThread } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseInputSearch from "@/components/BaseInputSearch";
import BaseMenu from "@/components/BaseMenu";
import BasePage from "@/components/BasePage";
import InfiniteScroll from "@/components/InfiniteScroll/InfiniteScroll.vue";
import PageTitle from "@/components/PageTitle";
import MessageThreadsEmptyView from "@/views/PageMessageThreads/components/MessageThreadsEmptyView.vue";
import MessageThreadItem from "./MessageThreadItem.vue";

export default defineComponent({
  name: "MessageThreadsView",
  components: {
    BaseInputSearch,
    InfiniteScroll,
    MessageThreadsEmptyView,
    BasePage,
    PageTitle,
    MessageThreadItem,
    BaseIcon,
    BaseMenu,
  },
  props: {
    loading: { type: Boolean, required: true },
    filterLoading: { type: Boolean, required: true },
    allowMassMessage: { type: Boolean, required: true },
    messageThreadList: { type: Array as () => MessageThread[], required: true },
    authUserId: { type: String, required: true },
    scroll: { type: Boolean, required: true },
    blockingStatus: { type: Array as () => BlockingStatus[], required: true },
    term: { type: String, required: true },
  },
  setup() {
    const { authorities } = useAuthUser();
    return {
      authorities,
    };
  },
  computed: {
    emptyThreads(): boolean {
      return !this.loading && this.messageThreadList.length === 0;
    },
    blockStatusList(): Record<string, boolean> {
      const list: Record<string, boolean> = {};
      this.blockingStatus.forEach(s => (list[s.blockedUserId] = true));
      return list;
    },
    allowMassMessageStat(): boolean {
      return checkAuthorities(this.authorities, ["updateMyContentPrice", "getMyMassMessageStat"]);
    },
    menuItems(): BaseMenuItem[] {
      const items = [];
      if (this.allowMassMessage) {
        items.push({
          name: "sendMassMessage",
          text: $t("Send Mass message"),
          prependIcon: "sci-send",
        });
      }
      if (this.allowMassMessageStat) {
        items.push({
          name: "statistics",
          text: $t("Statistics"),
          prependIcon: "sci-bar",
        });
      }
      return items;
    },
  },
  methods: {
    getBlockStatus(ids: string[]): boolean {
      const opponentId = ids[0] === this.authUserId ? ids[1] : ids[0];
      return this.blockStatusList[opponentId] ?? false;
    },
  },
});
